module.exports = __webpack_public_path__ + "img/xinxi.5ef4623f.png";